import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function StickyAlert() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-[#8B5A2B] shadow-2xl border-b-2 border-[#6F6F6F]" data-id="element-200">
      <div className="bg-leather" data-id="element-201">
        <div className="py-1.5 px-2 md:py-2 md:px-4" data-id="element-202">
          <div className="flex flex-row items-center justify-center gap-2 md:gap-4" data-id="element-203">
            <p className="text-[10px] md:text-sm font-bold text-[#E4D6B5] text-center tracking-wide uppercase whitespace-nowrap" data-id="element-204">
              ⚠ Oferta Lanzamiento Termina En:
            </p>
            <CountdownTimer data-id="element-205" />
          </div>
        </div>
      </div>
    </div>;
}